// Depends
import { route, group, subGroup, meta } from '@/helpers/routes'

import Create from './form/form'
import Index from './index/index'
import List from './list/form'

const guestRoutes = [
  route('create', '/create', Create, meta('Adicionar Lista', true, 'guest')),
  route('edit', '/:id/edit', Create, meta('Editar Lista', true, 'guest')),
  route('index', '/index', Index, meta('Lista de Convidado', true, 'guest')),
  route('list', '/:id/list', List, meta('Incluir Convidado', true, 'guest'))
]

export default [
  ...group('/app', [
    ...subGroup('/guest', guestRoutes)
  ])
]



// WEBPACK FOOTER //
// ./src/app/tenant/guest/routes.js